// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-7009525e] .modal-dialog{max-width:665px !important}[data-v-7009525e] .form-warning{font-size:12px !important}", ""]);
// Exports
module.exports = exports;
